/**
 * @flow
 * @relayHash b9717a80dac768c9a9033b2f247009a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EcommerceCategory_project$ref = any;
export type ecommerce_EcommerceCategory_QueryVariables = {|
  host: string
|};
export type ecommerce_EcommerceCategory_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: EcommerceCategory_project$ref
  |}
|};
export type ecommerce_EcommerceCategory_Query = {|
  variables: ecommerce_EcommerceCategory_QueryVariables,
  response: ecommerce_EcommerceCategory_QueryResponse,
|};
*/


/*
query ecommerce_EcommerceCategory_Query(
  $host: String!
) {
  project(host: $host) {
    ...EcommerceCategory_project
    id
  }
}

fragment EcommerceCategory_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      cursor
      node {
        countProducts
        countProductIssues
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ecommerce_EcommerceCategory_Query",
  "id": null,
  "text": "query ecommerce_EcommerceCategory_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...EcommerceCategory_project\n    id\n  }\n}\n\nfragment EcommerceCategory_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      cursor\n      node {\n        countProducts\n        countProductIssues\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ecommerce_EcommerceCategory_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EcommerceCategory_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ecommerce_EcommerceCategory_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countProducts",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countProductIssues",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '395bbdea2037615ef40fa3e115af950e';
module.exports = node;
